// extracted by mini-css-extract-plugin
export default {"svg":"Ring_svg__pm2-J","spin":"Ring_spin__37WXL","ring":"Ring_ring__rpTA9","ball":"Ring_ball__IQ6db"};